<template>
  <el-dialog
      title="Thêm khoản thu"
      :visible.sync="dialogVisibleAdd"
      width="1150px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      @open="handleOpen"
      top="4vh"
  >
    <el-form
        label-width="160px"
        :model="dataInput"
        label-position="left"
        :rules="rules"
        ref="dataInput"
    >
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="Chọn khoản" prop="idPackage">
            <el-select
                v-model="idPackage"
                placeholder="Chọn khoản"
                filterable
                @change="selectPackageMethod()"
                style="width: 100%"
            >
              <el-option
                  v-for="item in responseList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Loại" prop="category">
            <el-select
                disabled
                v-model="dataInput.category"
                @change="resetAttendanceMethod()"
                placeholder="Loại"
            >
              <el-option label="Thu" value="in"></el-option>
              <el-option label="Chi" value="out"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Mô tả" prop="description">
        <el-input
            disabled
            :rows="2"
            type="textarea"
            autosize
            v-model="dataInput.description"
            placeholder="Nhập mô tả"
        ></el-input>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Số lượng" prop="number">
            <el-input-number
                disabled
                v-model="dataInput.number"
                :precision="0"
                :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Đơn giá" prop="price">
            <el-currency-input v-model="dataInput.price" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Giảm giá" prop="discount">
            <el-radio-group v-model="dataInput.discount" disabled>
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInput.discount">
          <el-form-item label="Loại giảm giá" prop="discountType">
            <el-select v-model="dataInput.discountType" placeholder="Loại" disabled>
              <el-option label="Phần trăm" value="percent"></el-option>
              <el-option label="Tiền" value="money"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInput.discount">
          <el-form-item
              :label="dataInput.discountType === 'percent' ? 'Phần trăm giảm' : 'Tiền giảm'"
              prop="discountNumber"
          >
            <el-input-number
                disabled
                v-if="dataInput.discountType === 'percent'"
                v-model="dataInput.discountNumber"
                :precision="0"
                :min="0"
                :max="100"
            >
            </el-input-number>
            <el-currency-input
                disabled
                v-else-if="dataInput.discountType === 'money'"
                v-model="dataInput.discountNumber"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col v-if="dataInput.discount">
          <el-form-item label="Đơn giá khi giảm" prop="discountPrice">
            <currency-input
                disabled
                style="
                padding: 10px;
                width: 98%;
                text-align: right;
                background: #e7e9ec;
                border: 1px solid #dcdfe6;
                font-weight: bold;
              "
                v-model="dataInput.discountPrice"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Số tiền bằng chữ">
            <span style="font-weight: bold; font-style: italic;">{{ numberToWordsVN(dataInput.discountPrice) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Trạng thái sử dụng" prop="usingStatus">
            <el-radio-group v-model="dataInput.usingStatus" disabled>
              <el-radio :label="true">Đang sử dụng</el-radio>
              <el-radio :label="false" :disabled="exitClassOrGroup">Ngừng sử dụng</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Áp dụng điểm danh" prop="attendance">
            <el-radio-group v-model="dataInput.attendance" disabled>
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInput.attendance">
          <el-form-item label="Kiểu trả" prop="attendancePaid">
            <el-radio-group
                disabled
                v-model="dataInput.attendancePaid"
                @change="resetAttendanceMethod()"
            >
              <el-radio label="before">Trả trước</el-radio>
              <el-radio label="after">Trả sau</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="dataInput.attendance">
        <span v-if="dataInput.attendancePaid === 'before'">
          <el-col :span="8">
            <el-form-item label="Loại điểm danh" prop="attendanceType">
              <el-select
                  disabled
                  v-model="dataInput.attendanceType"
                  @change="changeAttendanceTypeMethod()"
                  placeholder="Chọn loại điểm danh"
              >
                <el-option
                    v-for="item in this.$funcData.funcAttendanceTypeNewList()"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="dataInput.attendanceType !== 'pickupLate'">
            <el-form-item label="Chi tiết" prop="attendanceDetail">
              <el-select
                  disabled
                  v-model="dataInput.attendanceDetail"
                  placeholder="Chọn chi tiết"
                  style="width: 250px"
              >
                <el-option
                    v-for="item in attendanceDetailNewList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </span>
        <span v-else-if="dataInput.attendancePaid === 'after'">
          <el-col :span="8">
            <el-form-item label="Loại điểm danh" prop="attendanceType">
              <el-select
                  disabled
                  v-model="dataInput.attendanceType"
                  @change="changeAttendanceTypeMethod()"
                  placeholder="Chọn loại điểm danh"
              >
                <el-option
                    v-for="item in attendanceTypeList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="dataInput.attendanceType !== 'pickupLate'">
            <el-form-item label="Chi tiết" prop="attendanceDetail">
              <el-select
                  disabled
                  v-model="dataInput.attendanceDetail"
                  placeholder="Chọn chi tiết"
                  style="width: 250px"
              >
                <el-option
                    v-for="item in attendanceDetailList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </span>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close" />
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
      >
        <i class="el-icon-circle-check" />
        <span>Thêm</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ElCurrencyInput from "@/components/ElCurrencyInput.vue";
import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import globalMixin from "@/global/mixin/global.mixin";

const valAttendanceTypeList = [
  { key: "goSchool", value: "Điểm danh đi học" },
  { key: "absentYes", value: "Nghỉ có phép" },
  { key: "absentNo", value: "Nghỉ không phép" },
  { key: "eat", value: "Điểm danh ăn" },
  { key: "pickupLate", value: "Đón muộn" },
];
const valAttendanceGoSchoolList = [
  { key: "morning", value: "Buổi sáng" },
  { key: "afternoon", value: "Buổi chiều" },
  { key: "evening", value: "Buổi tối" },
  { key: "allDay", value: "Cả ngày" },
];
const valAttendanceEatList = [
  { key: "eatBreakfast", value: "Bữa sáng" },
  { key: "eatBreakfastSecond", value: "Bữa phụ sáng" },
  { key: "eatLunch", value: "Bữa trưa" },
  { key: "eatAfternoon", value: "Bữa chiều" },
  { key: "eatAfternoonSecond", value: "Bữa phụ chiều" },
  { key: "eatDinner", value: "Bữa tối" },
  { key: "allDay", value: "Cả ngày" },
];

const valAttendanceDetailInNewList = [
  { key: "eatBreakfast1", value: "Thu tiền bữa sáng (1)" },
  { key: "eatRemain1", value: "Thu tiền bữa còn lại (1)" },
  { key: "eatDay2", value: "Thu tiền gói một ngày (2)" },
];
export default {
  name: "AddRevenueOutClassDialog",
  components: {
    ElCurrencyInput,
  },
  props: {
    dialogVisibleAdd: {
      type: Boolean,
      default: () => false
    },
    idClass: {
      type: [String, Number],
      default: () => ""
    },
    idGroup: {
      type: [String, Number],
      default: () => ""
    },
    type: {
      type: String,
      default: () => ""
    },
    dataUpdate: {
      type: Object,
      default: () => {}
    },
    exitClassOrGroup:{
      type: Boolean,
      default: () => false
    },
    idKid: {
      type: Number,
      default: () => 0
    }
  },

  data() {
    return {
      idPackage:"",
      responseList: [],
      dataInput: {
        id: 0,
        name: "",
        category: "",
        description: "",
        number: 1,
        price: 0,
        discount: false,
        discountType: "",
        discountNumber: 0,
        discountPrice: 0,
        usingStatus: true,
        attendance: false,
        attendancePaid: "",
        attendanceType: "",
        attendanceDetail: ""
      },
      attendanceTypeList: valAttendanceTypeList,
      attendanceGoSchoolList: valAttendanceGoSchoolList,
      attendanceEatList: valAttendanceEatList,
      attendanceDetailList: [],
      attendanceDetailInNewList: valAttendanceDetailInNewList,
      attendanceDetailNewList: [],
      checkAll: false,
      loadingButton: false,
    };
  },
  mixins: [globalMixin],
  watch: {
    dataInput: {
      handler: function () {
        let dataInputWatch = this.dataInput;
        let discountNumberWatch = dataInputWatch.discountNumber;
        let discountPriceWatch = dataInputWatch.price;
        let priceWatch = dataInputWatch.price;
        if (
            discountNumberWatch !== undefined &&
            discountNumberWatch !== "" &&
            discountNumberWatch !== 0 &&
            priceWatch !== undefined &&
            priceWatch !== "" &&
            priceWatch !== 0
        ) {
          if (dataInputWatch.discountType === "percent") {
            discountPriceWatch = (
                discountPriceWatch * ((100 - discountNumberWatch) / 100)
            );
          } else if (dataInputWatch.discountType === "money") {
            if (discountNumberWatch <= priceWatch) {
              discountPriceWatch = discountPriceWatch - discountNumberWatch;
            } else {
              this.$alert("Số tiền giảm không thể lớn hơn đơn giá", "Thông báo!", {
                confirmButtonText: "Đã hiểu",
                callback: () => {
                  this.dataInput.discountNumber = 0;
                },
              });
            }
          }
        }
        this.dataInput.discountPrice = discountPriceWatch;
      },
      deep: true,
    },
    changeAttendanceTypeComputed() {
      let dataInputComputed = this.dataInput;
      if (dataInputComputed.attendancePaid === "before") {
        if (dataInputComputed.attendanceType === "eatNew") {
          this.attendanceDetailNewList =
              dataInputComputed.category === "in"
                  ? this.attendanceDetailInNewList
                  : this.$funcData.getAttendanceDetailOutNewList();
        } else if (dataInputComputed.attendanceType === "arriveNew") {
          this.attendanceDetailNewList =
              dataInputComputed.category === "in"
                  ? this.$funcData.getAttendanceDetailArriveInList()
                  : this.$funcData.getAttendanceDetailArriveOutList();
        }
      } else if (dataInputComputed.attendancePaid === "after") {
        if (
            dataInputComputed.attendanceType === "absentYes" ||
            dataInputComputed.attendanceType === "absentNo"
        ) {
          this.attendanceDetailList = this.attendanceGoSchoolList;
        } else if (dataInputComputed.attendanceType === "goSchool") {
          this.attendanceDetailList = this.$funcData.getAttendanceGoSchooList();
        } else if (dataInputComputed.attendanceType === "eat") {
          this.attendanceDetailList = this.attendanceEatList;
        } else if (dataInputComputed.attendanceType === "pickupLate") {
          this.attendanceDetailList = [];
        }
      }
    },
  },
  computed: {
    changeAttendanceTypeComputed() {
      return [this.dataInput.attendanceType, this.dataInput.category];
    },
  },
  methods: {
    async handleOpen() {
      if (this.$props.type === 'CLASS'){
        await revenueManagementService.findAllRevenueManagementNoClass(this.$props.idClass)
            .then((res) => {
              this.responseList = res.data.data.managementResponseList;
            })
            .catch((err) => {
              NotifyMessage.leftCornerNotificationError(err.response.data.message);
            });
      } else if (this.$props.type === 'GROUP'){
        await revenueManagementService.findAllRevenueManagementNoGroup(this.$props.idGroup)
            .then((res) => {
              this.responseList = res.data.data.managementResponseList;
            })
            .catch((err) => {
              NotifyMessage.leftCornerNotificationError(err.response.data.message);
            });
      }

    },
    selectPackageMethod() {
      let idPackageSelected = this.idPackage;
      this.dataInput = this.responseList.filter((x) => x.id === idPackageSelected)[0];
    },
    //reset when click x
    closeDialog() {
      this.idPackage = ""
      this.responseList = []
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
        this.$refs["dataInput"].resetFields();
      }, 300);
    },
    changeAttendanceTypeMethod() {
      this.dataInput.attendanceDetail = "";
    },
    resetAttendanceMethod() {
      this.dataInput.attendanceType = "";
      this.dataInput.attendanceDetail = "";
    },
    submitForm() {
      this.$refs["dataInput"].validate((valid) => {
        if (valid) {

          if (this.idPackage === "" || this.idPackage === null || this.idPackage === undefined) {
            NotifyMessage.leftCornerNotificationWarning("Khoản không được để trống!");
            return
          }
          this.loadingButton = true;
          let data = {
            idKids: this.$props.idKid,
            idClass: this.$props.idClass,
            idGroup: this.$props.idGroup,
            idRevenueManagement: this.idPackage,
            type: "OUTCLASS"
          }
          if (this.$props.type === 'CLASS') {
            data.type = "OUTCLASS"
            data.idGroup = "0"
          } else {
            data.type = "OUTGROUP"
            data.idClass = "0"
          }
          revenueManagementService.addRevenueManagementOneStudent(data)
              .then(() => {
                NotifyMessage.leftCornerNotificationSuccess("Thêm khoản thành công!")
                setTimeout(() => {
                  this.closeDialog();
                }, 500);
              })
              .catch((err) => {
                console.log(err)
                NotifyMessage.leftCornerNotificationError("Thêm khoản thất bại!");
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
/deep/.el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}
/deep/.el-dialog__body {
  padding-bottom: 5px;
}
/deep/.el-input-number__decrease,
/deep/.el-input-number__increase {
  z-index: 1;
}
.el-input-number {
  width: 100%;
}
/deep/.el-radio__input.is-disabled+span.el-radio__label {
  color: #577cea;
  cursor: not-allowed;
}
/deep/.el-select .el-input.is-disabled .el-input__inner {
  color: #577cea;
  cursor: not-allowed;
}
/deep/.el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #577cea;
  cursor: not-allowed;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #577cea;
  cursor: not-allowed;
}
</style>
